import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvoices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/invoices", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/invoices/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/quotations/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editInvoice(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/invoices", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteInvoice(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/invoices", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteInvoiceSalary(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/invoices/salary", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteInvoiceCost(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/invoices/cost", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 獲取下一個發票編號
    getNextInvoiceNumber(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/invoices/next-number")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 驗證發票編號唯一性
    validateInvoiceNumber(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/invoices/validate-number", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 匯出發票資料
    exportInvoices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/invoices/export", {
            params: queryParams,
            responseType: 'blob'
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  }
};
